import { render, staticRenderFns } from "./ServiceInformationList.vue?vue&type=template&id=2c604eb9&scoped=true"
import script from "./ServiceInformationList.vue?vue&type=script&lang=js"
export * from "./ServiceInformationList.vue?vue&type=script&lang=js"
import style0 from "./ServiceInformationList.vue?vue&type=style&index=0&id=2c604eb9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c604eb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c604eb9')) {
      api.createRecord('2c604eb9', component.options)
    } else {
      api.reload('2c604eb9', component.options)
    }
    module.hot.accept("./ServiceInformationList.vue?vue&type=template&id=2c604eb9&scoped=true", function () {
      api.rerender('2c604eb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/components/ServiceInformationList.vue"
export default component.exports